import superagent from "superagent"
import { API_V2_URL } from "../../base"
import md5 from "js-md5"

export async function requestSMSCode(phoneNumber, userToken, languageCode) {
  const URL = `${API_V2_URL}phone_verifications/requests`
  const tokenAuth = `Token token=${userToken}`

  const res = await superagent
    .post(URL)
    .set("Authorization", tokenAuth)
    .send({
      phone_number: phoneNumber,
      unique_identifier: md5(userToken),
      language: languageCode,
    })
  return res.body
}

export async function verifySMSCode(phoneNumber, code, userToken) {
  const URL = `${API_V2_URL}phone_verifications/verifications`
  const tokenAuth = `Token token=${userToken}`

  const res = await superagent.post(URL).set("Authorization", tokenAuth).send({
    phone_number: phoneNumber,
    code: code,
  })
  return res.body
}
